import { BaseTableStateHandler } from "@hooks/use-table-context/utils";
import {
  AssetTableFilter,
  AssetTableContextValue,
  AssetTableData,
} from "./types";

export const ASSET_FILTER_TABLE_KEY = "assets";
// Bump whenever a filterable Asset field is renamed/removed so stale
// persisted filters are discarded instead of silently reapplied.
export const ASSET_FILTER_SCHEMA_VERSION = 1;

export class AssetTableStateHandler extends BaseTableStateHandler<AssetTableData, AssetTableFilter> {
  state: AssetTableContextValue;
  
  constructor(state: AssetTableContextValue) {
    super(state);
    this.state = state;
  }
}
